/**
 * Card Component Styles
 */

import { mode } from '../../system/color-mode';

export const cardStyles = {
  baseStyle: (props) => ({
    p: '20px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '20px',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('#ffffff', 'navy.800')(props),
    backgroundClip: 'border-box',
  }),

  variants: {
    elevated: (props) => ({
      bg: mode('white', 'gray.700')(props),
      boxShadow: mode('base', 'dark-lg')(props),
    }),
    outline: (props) => ({
      bg: mode('white', 'gray.800')(props),
      border: '1px solid',
      borderColor: mode('gray.200', 'whiteAlpha.300')(props),
    }),
    filled: (props) => ({
      bg: mode('gray.100', 'gray.700')(props),
    }),
    unstyled: {
      bg: 'none',
      p: 0,
    },
  },

  defaultProps: {
    variant: 'elevated',
  },
};

export const cardHeaderStyles = {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 4,
  },
};

export const cardBodyStyles = {
  baseStyle: {
    flex: 1,
    px: 0,
    py: 0,
  },
};

export const cardFooterStyles = {
  baseStyle: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    mt: 4,
    gap: 2,
  },
};

export default cardStyles;
